import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ModuleNumbers } from 'src/app/core/enums/module-numbers.enum';
import { MenuItemModel } from 'src/app/core/models/menu-id.model';
import { MenuStructureNavigationService } from 'src/app/core/services/menu-structure-navigation.service';

@Component({
  selector: 'app-menu-tree-search-result',
  templateUrl: './menu-tree-search-result.component.html',
  styleUrls: ['./menu-tree-search-result.component.scss'],
  standalone: false,
})
export class MenuTreeSearchResultComponent {
  private readonly menuStructureNavigationService = inject(MenuStructureNavigationService);

  @Input() item: Pick<MenuItemModel, 'id' | 'name'>;
  @Input() module: ModuleNumbers;
  @Input() ancestorPath = '';
  @Input() chosenElementId = '';
  @Output() readonly chosenElementClicked = new EventEmitter<string>();

  get itemUrl(): string | null {
    return this.menuStructureNavigationService.getNodeUrl(this.module, this.item.id);
  }

  async selectResult(event: MouseEvent): Promise<void> {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    const outcome = await this.menuStructureNavigationService.selectNode(this.module, this.item);
    if (this.menuStructureNavigationService.isCompleted(outcome)) {
      this.chosenElementClicked.emit(this.item.id);
    }
  }
}
